import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Featured from './components/Featured';
import Categories from './components/Categories';
import Features from './components/Features';
import Download from './components/Download';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@graph': [
              {
                '@type': 'WebPage',
                '@id': 'https://miguentry.github.io/#webpage',
                name: '咪咕漫画网-手机版阅读APP下载,安卓版/iOS版移动端入口',
                url: 'https://miguentry.github.io/',
                inLanguage: 'zh-CN',
                description:
                  '咪咕漫画网手机版专为移动端阅读优化，提供咪咕漫画网APP下载渠道，覆盖安卓版与iOS版。',
                isPartOf: { '@id': 'https://miguentry.github.io/#website' },
                primaryImageOfPage: {
                  '@type': 'ImageObject',
                  url: 'https://readdy.ai/api/search-image?query=vibrant%20manga%20comic%20reading%20banner%20with%20colorful%20cartoon%20characters%2C%20warm%20orange%20and%20gold%20tones%2C%20playful%20energetic%20illustration&width=1200&height=630&seq=og-cover&orientation=landscape',
                },
              },
              {
                '@type': 'Organization',
                '@id': 'https://miguentry.github.io/#organization',
                name: '咪咕漫画网',
                url: 'https://miguentry.github.io/',
                logo: { '@type': 'ImageObject', url: 'https://miguentry.github.io/vite.svg' },
              },
              {
                '@type': 'ItemList',
                name: '热门漫画推荐',
                itemListElement: [
                  { '@type': 'ListItem', position: 1, name: '星焰纪元' },
                  { '@type': 'ListItem', position: 2, name: '心动补习课' },
                  { '@type': 'ListItem', position: 3, name: '仙途问鼎' },
                ],
              },
              {
                '@type': 'FAQPage',
                mainEntity: [
                  {
                    '@type': 'Question',
                    name: '咪咕漫画网手机版和 APP 有什么区别？',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: '咪咕漫画网手机版是无需下载的网页版，点开即可在线阅读；APP 则提供离线缓存、更新推送和横屏翻页等更完整的体验，两者阅读进度支持云端同步。',
                    },
                  },
                  {
                    '@type': 'Question',
                    name: '如何下载咪咕漫画网 APP？安卓版和 iOS 版在哪里下？',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: '在页面顶部点击"下载 APP"即可看到安卓版与 iOS 版下载入口，安卓版提供安装包下载，iOS 版可通过应用商店获取。',
                    },
                  },
                  {
                    '@type': 'Question',
                    name: '咪咕漫画网 APP 支持离线缓存阅读吗？',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: '支持。在 APP 中打开任意漫画，点击缓存按钮即可将章节离线保存，没有网络也能在通勤路上流畅翻页阅读。',
                    },
                  },
                ],
              },
            ],
          }),
        }}
      />
      <Navbar />
      <main>
        <Hero />
        <Featured />
        <Categories />
        <Features />
        <Download />
        <Testimonials />
        <FAQ />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}